// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsLandlordApplicantDataWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ApplicantDetailsResponseDto,
  ApplicantSummaryResponseDto,
  GuarantorDetailsResponseDto,
  ListingAlias,
  Zuid,
} from '../..';

interface GetApplicantDetailsParams {
  applicantUserId: Zuid;
  applicationId: string;
  listingAlias: ListingAlias;
}
interface GetApplicantSummaryParams {
  applicantUserId: Zuid;
  applicationId: string;
  listingAlias: ListingAlias;
}
interface GetGuarantorDetailsParams {
  applicationId: string;
  invitingApplicantUserId: Zuid;
  listingAlias: ListingAlias;
}

export const CappsLandlordApplicantDataWebApiHandler_getApplicantDetails_Path =
  '/api/web/landlord/v1/applications/getApplicantDetails';

export const CappsLandlordApplicantDataWebApiHandler_getApplicantDetails = (
  getParams: GetApplicantDetailsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetApplicantDetailsParams, never, ApplicantDetailsResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsLandlordApplicantDataWebApiHandler_getApplicantDetails_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsLandlordApplicantDataWebApiHandler_getApplicantSummary_Path =
  '/api/web/landlord/v1/applications/getApplicantSummary';

export const CappsLandlordApplicantDataWebApiHandler_getApplicantSummary = (
  getParams: GetApplicantSummaryParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetApplicantSummaryParams, never, ApplicantSummaryResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsLandlordApplicantDataWebApiHandler_getApplicantSummary_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsLandlordApplicantDataWebApiHandler_getGuarantorDetails_Path =
  '/api/web/landlord/v1/applications/getGuarantorDetails';

export const CappsLandlordApplicantDataWebApiHandler_getGuarantorDetails = (
  getParams: GetGuarantorDetailsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetGuarantorDetailsParams, never, GuarantorDetailsResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsLandlordApplicantDataWebApiHandler_getGuarantorDetails_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};
